import React, { useState } from "react";
import styled from "styled-components/macro";
import Dialog from "@fluentui/react/lib/Dialog";
import { ResourceStrings } from "../../../ResourceStrings";
import Button from '../../shared/Button'
import * as Actions from '../../../store/actions';

export interface DeleteAccountDialogProps {
    hidden: boolean;
    onClose: () => void;
}

export default function DeleteAccountDialog(props: DeleteAccountDialogProps): JSX.Element {
    const [canDelete, setCanDelete] = useState(false);

    const onDeleteClick = (): void => {
        if (canDelete) {
            Actions.deleteAccount();
            props.onClose();
        }
    }

    return <DialogWrapper
        hidden={props.hidden}
        onDismiss={props.onClose}
        dialogContentProps={{
            showCloseButton: true,
            closeButtonAriaLabel: ResourceStrings.close(),
        }}
    >
        <Container>
            <div className="title-instruction semibold vertical-space">Delete Account</div>

            <div className="vertical-space red-text">
                This action will permanently delete your Developer Community account,
                personal data, and attachments. Your feedback will be anonymized.
            </div>

            <div className="vertical-space">
                {"Type 'delete' below to confirm that you really want to delete your account."}
            </div>

            <input
                className="delete-input vertical-space"
                onChange={(e) => setCanDelete(e.target.value === "delete")}
            />

            <div className="btn-container">
                <Button className="small-space" disabled={!canDelete} onClick={onDeleteClick}>Delete my account</Button>
                <Button buttonType="normal" className="small-space" onClick={props.onClose}>Cancel</Button>
            </div>

        </Container>
    </DialogWrapper>
}

const DialogWrapper = styled(Dialog)`
    .ms-Dialog-main {
        min-width: 20rem;
        max-width: 60rem;
        width: 50%;
    }
`;

const Container = styled.div`
    position: relative;

    .title-instruction {
        font-size: 1.8rem;
        line-height: 2.4rem;
        font-weight: 350;

        .btn-link {
            padding: 0;
            height: auto;
        }
    }

    .title-bar {
        display: flex;
        justify-content: flex-end;
    }

    .red-text {
        color: red;
    }

    .delete-input {
        min-height: 3rem;
    }

    .small-space {
        margin: 0 .5rem;
    }

    .vertical-space {
        margin-bottom: 2rem;
    }

    .btn-container {
        display: flex;
        justify-content: flex-end;
    }
`;

